import * as React from 'react';
import * as style from './style.css';
import { Button, UIHeading2, UIText1 } from '@cian/ui-kit';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ErrorScreen = _ref => {
  let {
    onReset,
    buttonTheme = 'fill_primary'
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: style['container'],
    children: [/*#__PURE__*/_jsx("div", {
      className: style['image'],
      children: /*#__PURE__*/_jsx("div", {
        className: style['logo']
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: style['description'],
      children: [/*#__PURE__*/_jsx(UIHeading2, {
        textAlign: "center",
        children: "\u0427\u0442\u043E-\u0442\u043E \u043F\u043E\u0448\u043B\u043E \u043D\u0435 \u0442\u0430\u043A"
      }), /*#__PURE__*/_jsx("div", {
        className: style['subtitle'],
        children: /*#__PURE__*/_jsx(UIText1, {
          textAlign: "center",
          children: "\u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0435\u0449\u0451 \u0440\u0430\u0437"
        })
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: style['controls'],
      children: /*#__PURE__*/_jsx(Button, {
        theme: buttonTheme,
        size: "M",
        onClick: onReset,
        children: "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C"
      })
    })]
  });
};